import RoomEnclosure2 from "./RoomEnclosure2";

export default function Room2() {
	return (
		<>
			<RoomEnclosure2 />
		</>
	);
}
